export default "__VITE_ASSET__Bi0i1MEH__"